import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { SvgIconComponent } from '@mui/icons-material';
import { Button } from '../Button';
import { IconSelectModal } from 'components/modals/IconSelectModal';
import { useModal } from 'utils/hooks';
import { getIcon } from 'utils/common';

interface Props {
  onSelected: (icon: string) => void;
}

export const IconSelect = memo(({ onSelected }: Props) => {
  const { t } = useTranslation();
  const [icon, setIcon] = useState<SvgIconComponent | null>(null);

  const { trigger } = useModal({
    component: IconSelectModal,
    key: 'iconSelect',
    defaultValues: {
      onConfirm: (e) => {
        onSelected(e);
        setIcon(getIcon(e));
      },
      onCancel: () => {},
    },
  });

  return (
    <div>
      <Button isSecondary icon={icon!} onClick={trigger}>
        {t('common.placeholder.icon')}
      </Button>
    </div>
  );
});
